import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const SECTIONS = [
  {
    title: '1. Overview',
    body: 'Transformerus is an AI-native software development platform operated by GET Corp LP (“we”, “us”). These Terms of Service govern your access to and use of the Transformerus website, applications, APIs, and AI build tools (collectively, the “Service”). By creating an account, signing in, or making a payment, you agree to be bound by these Terms.',
  },
  {
    title: '2. Eligibility',
    body: 'You must be at least 18 years old, legally capable of entering into a contract in your jurisdiction, and not be prohibited from using the Service under applicable law. If you use the Service on behalf of a company or other entity, you represent that you have authority to bind that entity to these Terms.',
  },
  {
    title: '3. Accounts & security',
    body: 'You are responsible for maintaining the confidentiality of your account credentials and for all activity that occurs under your account. Notify us immediately at support@transformerus.app if you believe your account has been compromised. We reserve the right to suspend any account engaged in fraudulent, abusive, or unlawful behaviour.',
  },
  {
    title: '4. Credits & billing',
    body: 'Paid features are metered in “credits”. Subscriptions and credit packs are billed via Stripe and PayPal in U.S. dollars unless stated otherwise. Subscriptions auto-renew at the end of each billing period until cancelled. Credit packs are one-time purchases and do not expire. Refunds are issued on a case-by-case basis and only for amounts that have not been consumed.',
  },
  {
    title: '5. Acceptable use',
    body: 'You agree not to: (a) reverse-engineer, scrape, or mirror the Service; (b) use the Service to build content or applications that are illegal, infringing, defamatory, or harmful; (c) generate spam, malware, or facilitate phishing; (d) train competing models on outputs from our Service without prior written permission; or (e) interfere with the security or operation of the Service.',
  },
  {
    title: '6. Intellectual property',
    body: 'You retain ownership of code, content, and inputs you provide. You grant us a worldwide, non-exclusive, royalty-free licence to use those inputs solely to provide and improve the Service. The Transformerus marks, logos, and the Service itself are owned by GET Corp LP. AI-generated outputs you create are yours to use, subject to applicable third-party model and licence terms.',
  },
  {
    title: '7. Third-party services',
    body: 'The Service depends on third-party providers including Stripe (payments), PayPal (payments), MongoDB (data), and frontier model providers (OpenAI, Anthropic, Google). Your use of those services is governed by their own terms. We are not responsible for outages or content originating from third parties.',
  },
  {
    title: '8. Disclaimers',
    body: 'The Service is provided “as is” and “as available”. AI outputs may be incorrect, incomplete, or unsuitable for production use without human review. We disclaim all implied warranties to the maximum extent permitted by law and do not guarantee uninterrupted or error-free operation.',
  },
  {
    title: '9. Limitation of liability',
    body: 'To the fullest extent permitted by law, GET Corp LP’s aggregate liability arising out of or relating to the Service shall not exceed the greater of (a) the amount you paid us in the twelve months preceding the claim, or (b) USD 100. We shall not be liable for indirect, incidental, special, consequential, or punitive damages.',
  },
  {
    title: '10. Termination',
    body: 'You may stop using the Service at any time and cancel paid plans from your account dashboard. We may suspend or terminate your access for breach of these Terms. Sections 4, 6, 8, 9, 11, and 12 survive termination.',
  },
  {
    title: '11. Governing law',
    body: 'These Terms are governed by the laws of England and Wales without regard to conflict-of-laws principles. The courts of London shall have exclusive jurisdiction over any dispute arising out of these Terms, except that we may seek injunctive relief in any competent court.',
  },
  {
    title: '12. Changes',
    body: 'We may update these Terms from time to time. Material changes will be notified via the Service or by email at least 14 days in advance. Continued use after the effective date constitutes acceptance.',
  },
  {
    title: '13. Contact',
    body: 'Questions about these Terms? Email support@transformerus.app or use the contact form at /contact. Postal: GET Corp LP, registered in the United Kingdom.',
  },
];

export default function TermsPage() {
  return (
    <div className="min-h-screen flex flex-col bg-white">
      <Navbar />
      <main className="flex-1 pt-28 pb-24">
        <div className="mx-auto max-w-3xl px-6">
          <span className="inline-flex px-3 py-1 rounded-full bg-neutral-100 text-xs font-medium text-neutral-700">Legal</span>
          <h1 className="font-display text-4xl lg:text-5xl font-bold text-neutral-900 tracking-tight mt-4">Terms of Service</h1>
          <p className="mt-3 text-neutral-500 text-sm">Last updated: {new Date().toLocaleDateString('en-GB', { year: 'numeric', month: 'long' })}</p>

          <div className="mt-10 space-y-8">
            {SECTIONS.map((s) => (
              <section key={s.title}>
                <h2 className="font-display text-xl font-semibold text-neutral-900">{s.title}</h2>
                <p className="mt-2 text-neutral-700 leading-relaxed">{s.body}</p>
              </section>
            ))}
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
